import { TextMap } from '../types'

import en from './en'
import zh from './zh'

const languages: { [lang: string]: TextMap } = { en, zh }

export default languages
